import styled from 'styled-components'

import { InputSmallText } from '@/atoms/typography'

export const SectionDescription = styled(InputSmallText)`
  margin-bottom: ${({ theme }) => theme.space.S12};
  padding: 0 ${({ theme }) => theme.space.S12};
  width: 100%;
  color: ${({ theme }) => theme.colors.grey};
`
